@if(!isHiddenProcess && isOpen){
<div class="overlay" *ngIf="!isChildPopupOpened">
    &nbsp;
</div>
<div class="toast-box-wrapper center-full"
    [ngClass]="isChildPopupOpened ? 'toast-box-wrapper-closed ' : 'toast-box-wrapper-opened'">
    <ngb-toast [header]="header && header.length > 0 ?  header : localService.languageContent.common.send_to_phone"
        [autohide]="false" (hidden)="onAction(1)">
        <div *ngIf="localService.languageContent && localService.languageContent.send_to_phone">
            <div class="row">
                <div class="col-4" style="text-align: right;">
                    <app-label
                        [Text]="localService.languageContent && localService.languageContent.send_to_phone.language" />
                </div>
                <div class="col-8">
                    <ngx-select [id]="elementIds.dd_print_language" [(ngModel)]="printingLanguage"
                        [noAutoComplete]="false" [items]="languagesEquivalent" [optionValueField]="'v1'"
                        [optionTextField]="'v3'">
                    </ngx-select>
                </div>
            </div>
            <app-mapping-container *ngIf="isShowMappingNumbers" [items]="contactNumbers"
                (onValuesUpdated)="onValuesUpdated($event)" [isOnlyNumbers]="true" [isGrouping]="true"
                [isFocusInput]="true" [isEnableDeleteOption]="true"
                [Title]="localService.languageContent.send_to_phone.mention_number"></app-mapping-container>
            <div class="row box" style="margin:5px;">
                <div class="col-12">
                    <app-label [Text]="'Receipt Template'" />
                    <div *ngFor="let item of receiptTemplateItems">
                        <label style="font-weight: normal; margin-left: 15px;">
                            <input type="checkbox" [(ngModel)]="item.isSelected" />
                            <span class="normal_color">{{item.value}}</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="note">
                        <div>
                            {{localService.languageContent.send_to_phone.note}}
                        </div>
                        <div style="margin-top: 10px;color: brown;">
                            <span>
                                {{localService.languageContent.send_to_phone.example}}
                            </span>
                            <span class="en">
                                &nbsp;:&nbsp;{{localService.languageContent.send_to_phone[countryCode]}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div style="color: red;font-size: 18px;" *ngIf="message && message.length > 0">
                        {{message}}
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <div>
                        <button class="button_icon button_icon_color icon_adjust" (click)="onLoad()"
                            [title]="localService.languageContent.send_to_phone.get_defaults">
                            refresh
                        </button>
                    </div>
                </div>
                <div class="col-6" style="text-align: right;">
                    <button type="button" class="btn btn-primary" style="font-size: 18px;"
                        (click)="onAction(2)">{{localService.languageContent.common.send}}</button>
                </div>
            </div>
        </div>
    </ngb-toast>
</div>
}